"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _emotionTheming = require("emotion-theming");
var _themes = require("../themes");
var useCustomTheme = function useCustomTheme() {
  var theme = (0, _emotionTheming.useTheme)();
  if (typeof theme.brandTag === 'undefined') {
    theme = _themes.wpeTheme;
  }
  return theme;
};
var _default = exports["default"] = useCustomTheme;